/* eslint-disable no-restricted-imports */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { utils } from 'ethers';
import JSBI from 'jsbi';
import { flatMap } from 'lodash';
export var maxValue = '115792089237316195423570985008687907853269984665640564039457584007913129639935'; //'BigNumber.from(2).pow(256).sub(1).toString()
export var isVariable = function (value) {
    if (!value)
        return false;
    if (typeof value !== 'object')
        return false;
    if ('id' in value) {
        return true;
    }
    if ('type' in value && value.type === 'address[]' && 'name' in value && value.name === 'path') {
        return true;
    }
    if ('type' in value && (value.type === 'computed' || value.type === 'validation')) {
        return true;
    }
    return false;
};
export var isOutputVariable = function (value) {
    if (!value)
        return false;
    if (typeof value !== 'object')
        return false;
    if (!isVariable(value))
        return false;
    return 'type' in value && (value.type === 'output' || value.type === 'computed' || value.type === 'validation');
};
export var getOutputVariable = function (_a) {
    var innerIndex = _a.innerIndex, nodeId = _a.nodeId, pluginType = _a.pluginType;
    if (typeof innerIndex !== 'number') {
        console.error('wrong output param');
        return undefined;
    }
    if (pluginType === 'COMPUTED')
        return {
            id: nodeId,
            type: 'computed',
        };
    var variable = {
        type: 'output',
        id: {
            innerIndex: innerIndex,
            nodeId: nodeId,
        },
    };
    return variable;
};
var tokenDestinations = [
    'erc20',
    'curve_pool',
    'curve_gauge',
    'yearn_vault',
    'ctoken',
    'curve_voting_escrow',
    'aave_pool_v3',
    'aave_lending_pool_v2',
    'uniswap_pool_v2',
];
var FctParam = /** @class */ (function () {
    function FctParam(_a) {
        var fctType = _a.fctType, appType = _a.appType, value = _a.value, mode = _a.mode, required = _a.required, innerIndex = _a.innerIndex, destination = _a.destination, rawValue = _a.rawValue, description = _a.description, options = _a.options, risk = _a.risk, messageType = _a.messageType, readonly = _a.readonly, innerType = _a.innerType, decimals = _a.decimals, hidden = _a.hidden, key = _a.key, virtual = _a.virtual, isPreview = _a.isPreview, icon = _a.icon;
        var _this = this;
        this.mode = 'ALL';
        this.required = true;
        this.readonly = false;
        this.isMultiParam = false;
        this.isPreview = false;
        this.subscribe = function (_a) {
            var callback = _a.callback, id = _a.id;
            _this.observers.set(id, callback);
        };
        this.unsubscribe = function (_a) {
            var id = _a.id;
            _this.observers.delete(id);
        };
        this.observers = new Map();
        this._isLoading = false;
        this._virtual = false;
        this._hidden = false;
        this.isConnectable = function (param) {
            return isConnectable({ from: param, to: _this });
        };
        this.getOutputVariable = function (nodeId, pluginType) {
            // if (typeof this.innerIndex !== 'number') return undefined
            if (pluginType === 'VALIDATION')
                return {
                    id: nodeId,
                    type: 'validation',
                };
            if (pluginType === 'COMPUTED')
                return {
                    id: nodeId,
                    type: 'computed',
                };
            var variable = {
                type: 'output',
                id: {
                    innerIndex: _this.innerIndex || 0,
                    nodeId: nodeId,
                },
            };
            return variable;
        };
        this.set = function (_a) {
            var value = _a.value;
            _this.value = value;
            _this.updateSubsciptions();
        };
        this.setString = function (_a) {
            var value = _a.value;
            return _this._setString({ value: value });
        };
        this.getString = function () {
            if (!_this.value)
                return _this.value;
            if (isVariable(_this.value))
                return _this.value;
            if (typeof _this.value === 'string')
                return _this.value;
            try {
                var stringValue = JSON.stringify(_this.value);
                return stringValue;
            }
            catch (e) {
                console.error(e);
                return _this.value;
            }
        };
        this.setQuiet = function (_a) {
            var value = _a.value;
            _this.value = value;
        };
        this.get = function () {
            if (!isVariable(_this.value)) {
                if (_this.fctType === 'bool') {
                    return _this.value === 'true';
                }
                if (!_this.fctType.includes("tuple") && _this.fctType.endsWith("[]")) {
                    if (typeof _this.value === 'string') {
                        try {
                            var parsedValue = JSON.parse(_this.value);
                            return parsedValue;
                        }
                        catch (e) {
                            console.error("failed to parse param value: ".concat(_this.value));
                            return _this.value;
                        }
                    }
                    return _this.value;
                }
                return _this.value;
            }
            var value = _this.value;
            if (value.type === 'address[]')
                return value.value;
            return value;
        };
        this.setEstimated = function (_a) {
            var value = _a.value;
            _this.estimatedValue = value;
            _this.updateSubsciptions();
        };
        this.setEstimatedString = function (_a) {
            var value = _a.value;
            if (isVariable(value))
                return;
            if (!value) {
                _this.estimatedValue = value;
                _this.updateSubsciptions();
                return;
            }
            if (_this.fctType === 'string[]' || _this.fctType === 'address[]' || _this.fctType === 'bool') {
                try {
                    _this.estimatedValue = JSON.parse(value);
                }
                catch (e) {
                    console.error({ setParamError: e });
                    _this.estimatedValue = value;
                }
                _this.updateSubsciptions();
                return;
            }
            _this.estimatedValue = value;
            _this.updateSubsciptions();
            return;
        };
        this.getEstimated = function () {
            return _this.estimatedValue;
        };
        this.isValid = function () {
            return { state: true, error: undefined };
        };
        this.reset = function () {
            _this.value = undefined;
        };
        this.updateSubsciptions = function () {
            var e_1, _a;
            try {
                for (var _b = __values(_this.observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var observer = _c.value;
                    observer[1](_this, _this.isLoading, undefined);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        this.setVariable = function (_a) {
            var _b;
            var value = _a.value;
            if (!isVariable(value))
                return;
            var variable = value;
            if (_this.fctType === 'address[]' && variable.type === 'external') {
                var paramValue = _this.value;
                var variableParamValue = paramValue;
                if (isVariable(variableParamValue) &&
                    variableParamValue.type === 'address[]' &&
                    ((_b = variableParamValue.value) === null || _b === void 0 ? void 0 : _b.length)) {
                    variableParamValue.value.push(variable);
                    _this.value = variableParamValue;
                    _this.updateSubsciptions();
                    return;
                }
                else {
                    _this.value = {
                        name: 'path',
                        type: 'address[]',
                        value: [variable],
                    };
                    _this.updateSubsciptions();
                    return;
                }
            }
            _this.value = value;
            _this.updateSubsciptions();
            return;
        };
        this._setString = function (_a) {
            var value = _a.value;
            if (!value) {
                _this.value = value;
                _this.updateSubsciptions();
                return;
            }
            if (isVariable(value)) {
                _this.setVariable({ value: value });
                return;
            }
            if (_this.appType === 'string[]' ||
                _this.appType === 'integer[]' ||
                _this.appType === 'number[]' ||
                _this.appType === 'address[]' ||
                _this.fctType === 'tuple[]') {
                try {
                    _this.value = JSON.parse(value);
                }
                catch (e) {
                    console.error({ setParamError: e });
                    _this.value = value;
                }
                _this.updateSubsciptions();
                return;
            }
            _this.value = value;
            _this.updateSubsciptions();
            return;
        };
        this.value = value;
        this.appType = appType;
        this._fctType = fctType;
        this.innerIndex = innerIndex;
        this.destination = destination;
        this.description = description;
        this.rawValue = rawValue;
        this.innerType = innerType || fctType;
        this.risk = risk;
        this._messageType = messageType;
        if (key)
            this.key = key;
        if (mode)
            this.mode = mode;
        if (virtual)
            this.virtual = virtual;
        if (isPreview)
            this.isPreview = isPreview;
        if (typeof required === 'boolean')
            this.required = required;
        if (typeof readonly === 'boolean')
            this.readonly = readonly;
        if (typeof hidden === 'boolean')
            this.hidden = hidden;
        if (decimals)
            this.decimals = decimals;
        if (Array.isArray(options))
            this.options = options;
        if (icon)
            this.icon = icon;
    }
    Object.defineProperty(FctParam.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (label) {
            this._label = label;
            //this.updateSubsciptions()
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FctParam.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        set: function (isLoading) {
            this._isLoading = isLoading;
            //this.updateSubsciptions()
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FctParam.prototype, "hidden", {
        get: function () {
            return this._hidden;
        },
        set: function (isHidden) {
            this._hidden = isHidden;
            // this.updateSubsciptions()
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FctParam.prototype, "virtual", {
        get: function () {
            return this._virtual;
        },
        set: function (isVirtual) {
            this._virtual = isVirtual;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FctParam.prototype, "decimals", {
        get: function () {
            return this._decimals;
        },
        set: function (label) {
            this._decimals = label;
            //this.updateSubsciptions()
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FctParam.prototype, "uiType", {
        get: function () {
            return this._uiType || this.appType;
        },
        set: function (type) {
            this._uiType = type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FctParam.prototype, "order", {
        get: function () {
            return this._order;
        },
        set: function (order) {
            this._order = order;
        },
        enumerable: false,
        configurable: true
    });
    FctParam.prototype.serializeIcon = function () {
        if (!this.icon)
            return undefined;
        // Handle react-feather icons
        if (typeof this.icon === 'function') {
            var iconName = this.icon.name;
            if (iconName) {
                return {
                    package: 'react-icons',
                    name: iconName,
                };
            }
        }
        return undefined;
    };
    FctParam.prototype.getJsonParam = function (_a) {
        var key = _a.key, ioType = _a.ioType;
        var _b = this, fctType = _b.fctType, appType = _b.appType, label = _b.label, hidden = _b.hidden, required = _b.required, estimatedValue = _b.estimatedValue, decimals = _b.decimals, nodeId = _b.nodeId, mode = _b.mode, description = _b.description, rawValue = _b.rawValue, destination = _b.destination, risk = _b.risk, readonly = _b.readonly, innerIndex = _b.innerIndex, isMultiParam = _b.isMultiParam, virtual = _b.virtual, uiType = _b.uiType, order = _b.order, symbol = _b.symbol, isPreview = _b.isPreview;
        return {
            get key() {
                return key;
            },
            get ioType() {
                return ioType;
            },
            get appType() {
                return appType;
            },
            get fctType() {
                return fctType;
            },
            value: this.getString(),
            label: label,
            hidden: hidden,
            required: required,
            estimatedValue: estimatedValue,
            messageType: this.getMessageType(),
            decimals: decimals,
            nodeId: nodeId,
            mode: mode,
            description: description,
            rawValue: rawValue,
            destination: destination,
            risk: risk,
            readonly: readonly,
            innerIndex: innerIndex,
            isMultiParam: isMultiParam,
            virtual: virtual,
            uiType: uiType,
            order: order,
            symbol: symbol,
            isPreview: isPreview,
            icon: this.serializeIcon(),
        };
    };
    FctParam.prototype.deserializeIcon = function (iconData) {
        if (!iconData)
            return undefined;
        try {
            if (iconData.package === 'react-icons') {
                var iconSet = require('react-icons/fa');
                return iconSet[iconData.name];
            }
        }
        catch (e) {
            console.warn('Failed to deserialize icon:', e);
        }
        return undefined;
    };
    FctParam.prototype.setJsonParam = function (param) {
        var _this = this;
        var key = param.key, fctType = param.fctType, appType = param.appType, value = param.value, ioType = param.ioType, icon = param.icon, rest = __rest(param, ["key", "fctType", "appType", "value", "ioType", "icon"]);
        if (fctType === 'tuple[]' && value && typeof value === 'string') {
            try {
                var array = JSON.parse(value);
                var valueString = flatMap(array, function (item) { return item; })
                    .map(function (item) { return item.value; })
                    .join();
                this.setString({ value: valueString });
            }
            catch (e) {
                console.warn(e);
                this._setString({ value: value });
            }
        }
        else {
            this._setString({ value: value });
        }
        if (icon) {
            this.icon = this.deserializeIcon(icon);
        }
        Object.keys(rest).forEach(function (key) {
            var paramKey = key;
            if (paramKey in _this) {
                _this[paramKey] = param[paramKey];
            }
        });
    };
    Object.defineProperty(FctParam.prototype, "fctType", {
        get: function () {
            return this._fctType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FctParam.prototype, "isVariable", {
        get: function () {
            var value = this.value;
            if (!value)
                return false;
            return isVariable(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FctParam.prototype, "isOutputVariable", {
        get: function () {
            var value = this.value;
            if (!value)
                return false;
            return isOutputVariable(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FctParam.prototype, "encodedValue", {
        get: function () {
            return utils.defaultAbiCoder.encode([this.fctType], [this.value]);
        },
        enumerable: false,
        configurable: true
    });
    FctParam.prototype.getMessageType = function () {
        return this._messageType;
    };
    return FctParam;
}());
export { FctParam };
export var isConnectable = function (_a) {
    var from = _a.from, to = _a.to;
    if (to.appType === 'anyType')
        return true;
    if (from.appType === 'anyType')
        return true;
    if (to.pluginType === 'COMPUTED' && to.key !== 'value1' && from.decimals !== to.decimals) {
        return false;
    }
    if (from.destination && (to.destination || to.fctType === 'bytes')) {
        if (tokenDestinations.includes(from.destination) &&
            (to.destination === 'erc20' || to.fctType === 'bytes'))
            return true;
        return from.destination === to.destination;
    }
    if (from.fctType === 'bytes') {
        return true;
    }
    if (to.fctType === 'bytes' && to.hashed) {
        return true;
    }
    if (from.fctType === 'bytes32' && to.fctType === 'bytes')
        return true;
    if (from.fctType === to.fctType)
        return true;
    if (from.appType !== to.appType)
        return false;
    var isFromArray = from.fctType.includes('[]');
    var isToArray = to.fctType.includes('[]');
    if (isFromArray !== isToArray)
        return false;
    var getNumber = function (value) {
        var parsedValue = value.match(/\d+/);
        return parsedValue ? parsedValue[0] : undefined;
    };
    var isLessEqual = function (value1, value2) {
        var number1 = getNumber(value1);
        var number2 = getNumber(value2);
        if (!number1 || !number2)
            return false;
        return true;
    };
    if (from.fctType.includes('uint') && to.fctType.includes('uint')) {
        return isLessEqual(from.fctType, to.fctType);
    }
    if (from.fctType.includes('int') && to.fctType.includes('int')) {
        // if (to.fctType.includes('uint')) return from.fctType === to.fctType
        return isLessEqual(from.fctType, to.fctType);
    }
    if (from.fctType.includes('bytes') && to.fctType.includes('bytes')) {
        if (!getNumber(to.fctType))
            return true;
        return isLessEqual(from.fctType, to.fctType);
    }
    return from.fctType === to.fctType;
};
var FctAmount = /** @class */ (function (_super) {
    __extends(FctAmount, _super);
    function FctAmount() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.isValid = function () {
            if (!_this.value)
                return { state: true, error: undefined };
            var value = _this.value;
            if (_this.isVariable)
                return { state: true, error: undefined };
            try {
                JSBI.BigInt(value).toString();
                return { state: true, error: undefined };
            }
            catch (e) {
                console.error({ error: e });
                return { state: false, error: 'Invalid Number' };
            }
        };
        return _this;
    }
    return FctAmount;
}(FctParam));
var FctAmount128 = /** @class */ (function (_super) {
    __extends(FctAmount128, _super);
    function FctAmount128() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.isValid = function () {
            if (!_this.value)
                return { state: true, error: undefined };
            var value = _this.value;
            if (_this.isVariable)
                return { state: true, error: undefined };
            try {
                JSBI.BigInt(value).toString();
                return { state: true, error: undefined };
            }
            catch (e) {
                console.error({ error: e });
                return { state: false, error: 'Invalid Number' };
            }
        };
        return _this;
    }
    return FctAmount128;
}(FctParam));
var FctInt256 = /** @class */ (function (_super) {
    __extends(FctInt256, _super);
    function FctInt256(args) {
        var _this = _super.call(this, __assign({ fctType: 'int256', appType: 'integer' }, args)) || this;
        _this.isValid = function () {
            if (!_this.value)
                return { state: true, error: undefined };
            var value = _this.value;
            if (_this.isVariable)
                return { state: true, error: undefined };
            try {
                JSBI.BigInt(value).toString();
                return { state: true, error: undefined };
            }
            catch (e) {
                console.error({ error: e });
                return { state: false, error: 'Invalid Number' };
            }
        };
        return _this;
    }
    return FctInt256;
}(FctParam));
export { FctInt256 };
var FctValue = /** @class */ (function (_super) {
    __extends(FctValue, _super);
    function FctValue(args) {
        return _super.call(this, __assign({ fctType: 'uint256', appType: 'integer' }, args)) || this;
    }
    return FctValue;
}(FctAmount));
export { FctValue };
var FctTimestamp = /** @class */ (function (_super) {
    __extends(FctTimestamp, _super);
    function FctTimestamp(args) {
        return _super.call(this, __assign({ fctType: 'uint256', appType: 'timestamp' }, args)) || this;
    }
    return FctTimestamp;
}(FctAmount));
export { FctTimestamp };
var FctDecimals = /** @class */ (function (_super) {
    __extends(FctDecimals, _super);
    function FctDecimals(args) {
        return _super.call(this, __assign({ fctType: 'uint256', appType: 'decimals' }, args)) || this;
    }
    return FctDecimals;
}(FctAmount));
export { FctDecimals };
var FctValue18 = /** @class */ (function (_super) {
    __extends(FctValue18, _super);
    function FctValue18(args) {
        var _this = _super.call(this, __assign({ fctType: 'uint256', appType: 'integer18' }, args)) || this;
        _this.decimals = 18;
        return _this;
    }
    return FctValue18;
}(FctAmount));
export { FctValue18 };
var FctValue27 = /** @class */ (function (_super) {
    __extends(FctValue27, _super);
    function FctValue27(args) {
        var _this = _super.call(this, __assign({ fctType: 'uint256', appType: 'integer27' }, args)) || this;
        _this.decimals = 27;
        return _this;
    }
    return FctValue27;
}(FctAmount));
export { FctValue27 };
var FctBps = /** @class */ (function (_super) {
    __extends(FctBps, _super);
    function FctBps(args) {
        var _this = _super.call(this, __assign({ fctType: 'uint256', appType: 'bps' }, args)) || this;
        _this.decimals = 4;
        return _this;
    }
    return FctBps;
}(FctAmount));
export { FctBps };
var FctUinteger32Bps = /** @class */ (function (_super) {
    __extends(FctUinteger32Bps, _super);
    function FctUinteger32Bps(args) {
        var _this = _super.call(this, __assign({ fctType: 'uint32', appType: 'bps' }, args)) || this;
        _this.decimals = 4;
        return _this;
    }
    return FctUinteger32Bps;
}(FctParam));
export { FctUinteger32Bps };
var FctPercent = /** @class */ (function (_super) {
    __extends(FctPercent, _super);
    function FctPercent(args) {
        var _this = _super.call(this, __assign({ fctType: 'uint256', appType: 'integer' }, args)) || this;
        _this.isValid = function () {
            if (!_this.value)
                return { state: true, error: undefined };
            if (_this.isVariable)
                return { state: true, error: undefined };
            try {
                var amount = parseFloat(_this.value);
                if (amount >= 0) {
                    return { state: true, error: undefined };
                }
                return { state: false, error: 'Invalid Percent' };
            }
            catch (e) {
                console.error({ error: e });
                return { state: false, error: 'Invalid Percent' };
            }
        };
        return _this;
    }
    return FctPercent;
}(FctParam));
export { FctPercent };
var FctValue8 = /** @class */ (function (_super) {
    __extends(FctValue8, _super);
    function FctValue8(args) {
        return _super.call(this, __assign({ fctType: 'uint8', appType: 'integer' }, args)) || this;
    }
    return FctValue8;
}(FctParam));
export { FctValue8 };
var FctUInt80 = /** @class */ (function (_super) {
    __extends(FctUInt80, _super);
    function FctUInt80(args) {
        return _super.call(this, __assign({ fctType: 'uint80', appType: 'integer' }, args)) || this;
    }
    return FctUInt80;
}(FctParam));
export { FctUInt80 };
var FctUInt112 = /** @class */ (function (_super) {
    __extends(FctUInt112, _super);
    function FctUInt112(args) {
        return _super.call(this, __assign({ fctType: 'uint112', appType: 'integer' }, args)) || this;
    }
    return FctUInt112;
}(FctParam));
export { FctUInt112 };
var FctValue16 = /** @class */ (function (_super) {
    __extends(FctValue16, _super);
    function FctValue16(args) {
        return _super.call(this, __assign({ fctType: 'uint16', appType: 'integer' }, args)) || this;
    }
    return FctValue16;
}(FctParam));
export { FctValue16 };
var FctValue24 = /** @class */ (function (_super) {
    __extends(FctValue24, _super);
    function FctValue24(args) {
        return _super.call(this, __assign({ fctType: 'uint24', appType: 'integer' }, args)) || this;
    }
    return FctValue24;
}(FctParam));
export { FctValue24 };
var FctValue40 = /** @class */ (function (_super) {
    __extends(FctValue40, _super);
    function FctValue40(args) {
        return _super.call(this, __assign({ fctType: 'uint40', appType: 'integer' }, args)) || this;
    }
    return FctValue40;
}(FctParam));
export { FctValue40 };
var FctValue128 = /** @class */ (function (_super) {
    __extends(FctValue128, _super);
    function FctValue128(args) {
        return _super.call(this, __assign({ fctType: 'uint128', appType: 'integer' }, args)) || this;
    }
    return FctValue128;
}(FctParam));
export { FctValue128 };
var FctValue128_27 = /** @class */ (function (_super) {
    __extends(FctValue128_27, _super);
    function FctValue128_27(args) {
        var _this = _super.call(this, __assign({ fctType: 'uint256', appType: 'integer27' }, args)) || this;
        _this.decimals = 27;
        return _this;
    }
    return FctValue128_27;
}(FctAmount128));
export { FctValue128_27 };
var FctValue160 = /** @class */ (function (_super) {
    __extends(FctValue160, _super);
    function FctValue160(args) {
        return _super.call(this, __assign({ fctType: 'uint160', appType: 'integer' }, args)) || this;
    }
    return FctValue160;
}(FctParam));
export { FctValue160 };
var FctAddress = /** @class */ (function (_super) {
    __extends(FctAddress, _super);
    function FctAddress(args) {
        var _this = _super.call(this, __assign({ fctType: 'address', appType: 'address' }, args)) || this;
        _this.isValid = function () {
            if (!_this.value)
                return { state: true, error: undefined };
            if (_this.isVariable)
                return { state: true, error: undefined };
            var value = _this.value;
            if (value === 'NATIVE')
                return { state: true, error: undefined };
            if (!utils.isAddress(value)) {
                return { state: false, error: 'Invalid Address' };
            }
            return { state: true, error: undefined };
        };
        return _this;
    }
    return FctAddress;
}(FctParam));
export { FctAddress };
var FctAddressList = /** @class */ (function (_super) {
    __extends(FctAddressList, _super);
    function FctAddressList(args) {
        var _this = _super.call(this, __assign({ fctType: 'address[]', appType: 'address[]' }, args)) || this;
        _this.paramFctType = 'address';
        _this.paramAppType = 'address';
        _this.setString = function (_a) {
            var value = _a.value;
            if (!value) {
                _this.value = value;
                return;
            }
            if (isVariable(value)) {
                _this._setString({ value: value });
                return;
            }
            if (typeof value !== 'string')
                return;
            var params = [];
            try {
                JSON.parse(value);
                console.error("wrong value: ".concat(value, " for ").concat(_this.key, " param"));
            }
            catch (error) {
                value.split(',').forEach(function (param) {
                    params.push(param);
                });
                _this.value = params;
            }
        };
        return _this;
    }
    return FctAddressList;
}(FctParam));
export { FctAddressList };
var FctStringList = /** @class */ (function (_super) {
    __extends(FctStringList, _super);
    function FctStringList(args) {
        var _this = _super.call(this, __assign({ fctType: 'string[]', appType: 'string[]' }, args)) || this;
        _this.paramFctType = 'string';
        _this.paramAppType = 'string';
        _this.setString = function (_a) {
            var value = _a.value;
            if (!value) {
                _this.value = value;
                return;
            }
            if (isVariable(value)) {
                _this._setString({ value: value });
                return;
            }
            if (typeof value !== 'string')
                return;
            var params = [];
            try {
                JSON.parse(value);
                console.error("wrong value: ".concat(value, " for ").concat(_this.key, " param"));
            }
            catch (error) {
                value.split(',').forEach(function (param) {
                    params.push(param);
                });
                _this.value = params;
            }
        };
        return _this;
    }
    return FctStringList;
}(FctParam));
export { FctStringList };
var FctValueList = /** @class */ (function (_super) {
    __extends(FctValueList, _super);
    function FctValueList(args) {
        var _this = _super.call(this, __assign({ fctType: 'uint256[]', appType: 'integer[]' }, args)) || this;
        _this.paramFctType = 'uint256';
        _this.paramAppType = 'integer';
        _this.setString = function (_a) {
            var value = _a.value;
            if (!value) {
                _this.value = value;
                return;
            }
            if (isVariable(value)) {
                _this.value = value;
                return;
            }
            if (typeof value !== 'string')
                return;
            var params = [];
            try {
                JSON.parse(value);
                console.error("wrong value: ".concat(value, " for ").concat(_this.key, " param"));
            }
            catch (error) {
                value.split(',').forEach(function (param) {
                    params.push(param);
                });
                _this.value = params;
            }
        };
        return _this;
    }
    return FctValueList;
}(FctParam));
export { FctValueList };
var FDBackBase = '0xFDB0000000000000000000000000000000000000';
var FDBackBaseBytes = '0xFDB0000000000000000000000000000000000000000000000000000000000000';
var FDBase = '0xFD00000000000000000000000000000000000000';
var FDBaseBytes = '0xFD00000000000000000000000000000000000000000000000000000000000000';
export var getOutputVariableOnChain = function (_a) {
    var index = _a.index, innerIndex = _a.innerIndex, _b = _a.type, type = _b === void 0 ? 'uint256' : _b;
    var outputIndexHex = (index + 1).toString(16).padStart(4, '0');
    var base;
    var innerIndexHex;
    innerIndex = innerIndex !== null && innerIndex !== void 0 ? innerIndex : 0;
    if (innerIndex < 0) {
        innerIndexHex = ((innerIndex + 1) * -1).toString(16).padStart(4, '0');
        if (type.includes('bytes')) {
            base = FDBackBaseBytes;
        }
        else {
            base = FDBackBase;
        }
    }
    else {
        innerIndexHex = innerIndex.toString(16).padStart(4, '0');
        if (type.includes('bytes')) {
            base = FDBaseBytes;
        }
        else {
            base = FDBase;
        }
    }
    return (innerIndexHex + outputIndexHex).padStart(base.length, base);
};
var FctValueListN = /** @class */ (function (_super) {
    __extends(FctValueListN, _super);
    function FctValueListN(args) {
        var _this = _super.call(this, __assign({ fctType: 'uint256[n]', appType: 'integer[]' }, args)) || this;
        _this.setString = function (_a) {
            var value = _a.value;
            if (!value) {
                _this.value = value;
                return;
            }
            if (isVariable(value)) {
                return;
            }
            if (typeof value !== 'string')
                return;
            var params = [];
            try {
                JSON.parse(value);
                console.error("wrong value: ".concat(value, " for ").concat(_this.key, " param"));
            }
            catch (error) {
                value.split(',').forEach(function (param) {
                    params.push(param);
                });
                _this.value = params;
            }
        };
        return _this;
    }
    Object.defineProperty(FctValueListN.prototype, "fctType", {
        get: function () {
            try {
                var value = this.value;
                var parsedValue = typeof value === 'string' ? JSON.parse(value) : value;
                var length_1 = parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.length;
                if (length_1) {
                    return "uint256[".concat(length_1, "]");
                }
                return this._fctType;
            }
            catch (e) {
                return this._fctType;
            }
        },
        enumerable: false,
        configurable: true
    });
    return FctValueListN;
}(FctParam));
export { FctValueListN };
var FctBytes32 = /** @class */ (function (_super) {
    __extends(FctBytes32, _super);
    function FctBytes32(args) {
        var _this = _super.call(this, __assign({ fctType: 'bytes32', appType: 'bytes32' }, args)) || this;
        if (args.messageType) {
            _this.appType = args.messageType;
            return _this;
        }
        _this.appType = 'bytes32';
        return _this;
    }
    FctBytes32.prototype.getMessageType = function () {
        if ((this._messageType === 'stringOrBytes32' || this._messageType === 'string') &&
            this.value &&
            typeof this.value === 'string') {
            if (utils.isBytesLike(this.value)) {
                return 'bytes32';
            }
            return 'string';
        }
        return 'bytes32';
    };
    return FctBytes32;
}(FctParam));
export { FctBytes32 };
var FctAnyType = /** @class */ (function (_super) {
    __extends(FctAnyType, _super);
    function FctAnyType(args) {
        var _this = _super.call(this, __assign({ fctType: 'bytes32', appType: 'anyType' }, args)) || this;
        _this.setValue = function (value) {
            _this.value = _this.getParsedValue({ value: value }).parsedValue;
        };
        _this.get = function () { return _this.getParsedValue({ value: _this.value }).parsedValue; };
        _this.getParsedValue = function (_a) {
            var value = _a.value;
            if (!value)
                return { type: undefined, value: value, parsedValue: value };
            if (isVariable(value))
                return { type: 'variable', value: value, parsedValue: value };
            try {
                if (utils.isBytesLike(value)) {
                    if (utils.isAddress(value)) {
                        return { type: 'address', value: value, parsedValue: utils.defaultAbiCoder.encode(['address'], [value]) };
                    }
                    else {
                        var bytesCount = (value.length - 2) / 2;
                        return {
                            type: 'bytes',
                            value: value,
                            parsedValue: utils.defaultAbiCoder.encode(["bytes".concat(bytesCount)], [value]),
                        };
                    }
                }
                if (isNaN(Number(value))) {
                    return {
                        type: 'string',
                        value: value,
                        parsedValue: utils.formatBytes32String(value),
                    };
                }
                else if (Number(value) >= 0) {
                    return {
                        type: 'uint256',
                        value: value,
                        parsedValue: utils.defaultAbiCoder.encode(['uint256'], [value]),
                    };
                }
                else {
                    return {
                        type: 'int256',
                        value: value,
                        parsedValue: value,
                    };
                }
            }
            catch (e) {
                console.error(e);
                return {
                    type: 'invalid',
                    value: value,
                    parsedValue: value,
                    message: ((e === null || e === void 0 ? void 0 : e.message) || (e === null || e === void 0 ? void 0 : e.response)),
                };
            }
        };
        _this.isValid = function () {
            var parsedValue = _this.getParsedValue({ value: _this.value });
            if (parsedValue.type === 'invalid')
                return { state: false, error: parsedValue.message };
            if (parsedValue.type === 'string' && parsedValue.value.length > 32)
                return { state: false, error: 'Invalid string length should be less than 32' };
            return { state: true, error: undefined };
        };
        return _this;
    }
    return FctAnyType;
}(FctParam));
export { FctAnyType };
var FctBytes32List = /** @class */ (function (_super) {
    __extends(FctBytes32List, _super);
    function FctBytes32List(args) {
        return _super.call(this, __assign({ fctType: 'bytes32[]', appType: 'string[]' }, args)) || this;
    }
    return FctBytes32List;
}(FctParam));
export { FctBytes32List };
var FctBytes4 = /** @class */ (function (_super) {
    __extends(FctBytes4, _super);
    function FctBytes4(args) {
        return _super.call(this, __assign({ fctType: 'bytes4', appType: 'string' }, args)) || this;
    }
    return FctBytes4;
}(FctParam));
export { FctBytes4 };
var FctBytes = /** @class */ (function (_super) {
    __extends(FctBytes, _super);
    function FctBytes(args) {
        var _this = _super.call(this, __assign({ fctType: 'bytes', appType: 'bytes' }, args)) || this;
        if (args.messageType) {
            _this.appType = args.messageType;
            return _this;
        }
        _this.appType = 'bytes';
        return _this;
    }
    FctBytes.prototype.getMessageType = function () {
        if ((this._messageType === 'stringOrBytes' || this._messageType === 'string') &&
            this.value &&
            typeof this.value === 'string') {
            if (utils.isBytesLike(this.value)) {
                return 'bytes';
            }
            return 'string';
        }
        return 'bytes';
    };
    return FctBytes;
}(FctParam));
export { FctBytes };
var FctBytesList = /** @class */ (function (_super) {
    __extends(FctBytesList, _super);
    function FctBytesList(args) {
        return _super.call(this, __assign({ fctType: 'bytes[]', appType: 'string[]' }, args)) || this;
    }
    return FctBytesList;
}(FctParam));
export { FctBytesList };
var FctString = /** @class */ (function (_super) {
    __extends(FctString, _super);
    function FctString(args) {
        return _super.call(this, __assign({ fctType: 'string', appType: 'string' }, args)) || this;
    }
    return FctString;
}(FctParam));
export { FctString };
var FctTextarea = /** @class */ (function (_super) {
    __extends(FctTextarea, _super);
    function FctTextarea(args) {
        return _super.call(this, __assign({ fctType: 'string', appType: 'textarea' }, args)) || this;
    }
    return FctTextarea;
}(FctParam));
export { FctTextarea };
var FctJSON = /** @class */ (function (_super) {
    __extends(FctJSON, _super);
    function FctJSON(args) {
        return _super.call(this, __assign({ fctType: 'string', appType: 'JSON' }, args)) || this;
    }
    return FctJSON;
}(FctParam));
export { FctJSON };
var FctImage = /** @class */ (function (_super) {
    __extends(FctImage, _super);
    function FctImage(args) {
        return _super.call(this, __assign({ fctType: 'string', appType: 'image' }, args)) || this;
    }
    return FctImage;
}(FctParam));
export { FctImage };
var FctTradingGraphProps = /** @class */ (function (_super) {
    __extends(FctTradingGraphProps, _super);
    function FctTradingGraphProps(args) {
        var initProps = JSON.stringify({
            label: '',
            protocol: 'uniswapv2',
            fromToken: '',
            toToken: '',
            maxPrice: '',
            minPrice: '',
            fromSymbol: '',
            toSymbol: '',
            fromDecimals: 0,
            toDecimals: 0,
            minDescription: '',
            maxDescription: '',
        });
        return _super.call(this, __assign({ fctType: initProps, appType: initProps }, args)) || this;
    }
    return FctTradingGraphProps;
}(FctParam));
export { FctTradingGraphProps };
var FctTupleArray = /** @class */ (function (_super) {
    __extends(FctTupleArray, _super);
    function FctTupleArray(args) {
        var _this = this;
        var argParams = args.params;
        if (!argParams) {
            return _this;
        }
        var appTypes = Object.keys(argParams).map(function (key) {
            var param = argParams[key];
            return "".concat(key, " ").concat(param.paramAppType);
        });
        _this = _super.call(this, __assign({ fctType: 'tuple[]', appType: appTypes.join() }, args)) || this;
        _this.tupleInterface = '';
        _this.tupleType = '';
        _this.params = {};
        _this.setString = function (_a) {
            var value = _a.value;
            if (!value) {
                _this.value = value;
                return;
            }
            if (isVariable(value)) {
                _this.value = value;
                return;
            }
            if (typeof value !== 'string')
                return;
            try {
                JSON.parse(value);
                console.error("wrong value: ".concat(value, " for ").concat(_this.key, " param"));
            }
            catch (error) {
                var params_1 = [];
                var subParam_1 = [];
                Object.keys(_this.params).forEach(function (key) {
                    _this.params[key].set({ value: [] });
                });
                value.split(',').forEach(function (param, i) {
                    var paramIndex = i % Object.keys(_this.params).length;
                    var paramKey = Object.keys(_this.params)[paramIndex];
                    var tupleParam = _this.params[paramKey];
                    switch (tupleParam.paramFctType) {
                        case 'address':
                            if (!param)
                                break;
                            if (!utils.isAddress(param)) {
                                console.error("wrong value: ".concat(param, " should be ").concat(tupleParam.paramFctType, " type"));
                                return;
                            }
                            break;
                        case 'uint256':
                            if (!param)
                                break;
                            try {
                                JSBI.BigInt(param).toString();
                                break;
                            }
                            catch (e) {
                                console.error("wrong value: ".concat(param, " should be ").concat(tupleParam.paramFctType, " type"));
                                return;
                            }
                        default:
                            break;
                    }
                    if (paramIndex === 0) {
                        if (subParam_1.length) {
                            params_1.push(subParam_1);
                        }
                        subParam_1 = [];
                    }
                    var prevTupleValue = tupleParam.value || [];
                    tupleParam.set({ value: __spreadArray(__spreadArray([], __read(prevTupleValue), false), [param], false) });
                    subParam_1.push({
                        name: paramKey,
                        type: tupleParam.paramFctType,
                        value: param,
                        virtual: tupleParam.virtual,
                    });
                });
                params_1.push(subParam_1);
                _this.value = params_1;
            }
        };
        _this.getFctParams = function () {
            if (!_this.value)
                return _this.value;
            if (isVariable(_this.value))
                return _this.value;
            var value = _this.value;
            return value === null || value === void 0 ? void 0 : value.map(function (p) { return p.filter(function (p) { return !p.virtual; }); });
        };
        _this.params = argParams;
        _this.tupleInterface = '(';
        _this.tupleType = '(';
        Object.keys(argParams).forEach(function (key) {
            var param = argParams[key];
            if (param.virtual)
                return;
            _this.tupleInterface += "".concat(param.paramFctType, " ").concat(param.key, ",");
            _this.tupleType += "".concat(param.paramFctType, ",");
        });
        _this.tupleInterface = _this.tupleInterface.slice(0, -1);
        _this.tupleInterface += ')[]';
        _this.tupleType = _this.tupleType.slice(0, -1);
        _this.tupleType += ')[]';
        return _this;
    }
    return FctTupleArray;
}(FctParam));
export { FctTupleArray };
var FctBoolean = /** @class */ (function (_super) {
    __extends(FctBoolean, _super);
    function FctBoolean(args) {
        return _super.call(this, __assign({ fctType: 'bool', appType: 'boolean', value: 'true' }, args)) || this;
    }
    return FctBoolean;
}(FctParam));
export { FctBoolean };
var FctRadio = /** @class */ (function (_super) {
    __extends(FctRadio, _super);
    function FctRadio(args) {
        return _super.call(this, __assign({ fctType: 'bool', appType: 'radio' }, args)) || this;
    }
    return FctRadio;
}(FctParam));
export { FctRadio };
var FctInteger24 = /** @class */ (function (_super) {
    __extends(FctInteger24, _super);
    function FctInteger24(args) {
        return _super.call(this, __assign({ fctType: 'int24', appType: 'integer' }, args)) || this;
    }
    return FctInteger24;
}(FctParam));
export { FctInteger24 };
var FctInteger64 = /** @class */ (function (_super) {
    __extends(FctInteger64, _super);
    function FctInteger64(args) {
        return _super.call(this, __assign({ fctType: 'int64', appType: 'integer' }, args)) || this;
    }
    return FctInteger64;
}(FctParam));
export { FctInteger64 };
var FctInteger32 = /** @class */ (function (_super) {
    __extends(FctInteger32, _super);
    function FctInteger32(args) {
        return _super.call(this, __assign({ fctType: 'int32', appType: 'integer' }, args)) || this;
    }
    return FctInteger32;
}(FctParam));
export { FctInteger32 };
var FctUinteger64 = /** @class */ (function (_super) {
    __extends(FctUinteger64, _super);
    function FctUinteger64(args) {
        return _super.call(this, __assign({ fctType: 'uint64', appType: 'integer' }, args)) || this;
    }
    return FctUinteger64;
}(FctParam));
export { FctUinteger64 };
var FctUinteger32 = /** @class */ (function (_super) {
    __extends(FctUinteger32, _super);
    function FctUinteger32(args) {
        return _super.call(this, __assign({ fctType: 'uint32', appType: 'integer' }, args)) || this;
    }
    return FctUinteger32;
}(FctParam));
export { FctUinteger32 };
var FctInteger128 = /** @class */ (function (_super) {
    __extends(FctInteger128, _super);
    function FctInteger128(args) {
        return _super.call(this, __assign({ fctType: 'int128', appType: 'integer' }, args)) || this;
    }
    return FctInteger128;
}(FctParam));
export { FctInteger128 };
var FctCustom = /** @class */ (function (_super) {
    __extends(FctCustom, _super);
    function FctCustom(args) {
        return _super.call(this, __assign({ fctType: 'unknown', appType: 'string' }, args)) || this;
    }
    return FctCustom;
}(FctParam));
export { FctCustom };
var FctCustomArray = /** @class */ (function (_super) {
    __extends(FctCustomArray, _super);
    function FctCustomArray(args) {
        var _this = _super.call(this, __assign({ fctType: 'unknown', appType: 'string[]' }, args)) || this;
        _this.paramAppType = 'string';
        _this.paramFctType = 'unknown';
        return _this;
    }
    return FctCustomArray;
}(FctParam));
export { FctCustomArray };
export var paramsSchemas = [
    FctAddress,
    FctBytes32,
    FctBoolean,
    FctAddressList,
    FctValue,
    FctBytes,
    FctValueList,
    FctValue8,
    FctValue16,
    FctValue24,
    FctValue40,
    FctValue128,
    FctValue160,
    FctString,
    FctBytes4,
    FctBytes32List,
    FctInteger24,
    FctInteger32,
    FctInteger64,
    FctUinteger32,
    FctUinteger64,
    FctInteger128,
    FctValueListN,
    FctTimestamp,
    FctDecimals,
    FctBps,
    FctValue18,
    FctValue27,
    FctInt256,
    FctCustom,
    FctBytesList,
    FctUInt80,
    FctUInt112,
    FctCustomArray,
    FctTupleArray,
    FctUinteger32Bps,
    FctAnyType,
    FctRadio,
    FctImage,
    FctTradingGraphProps,
    FctJSON,
    FctStringList,
    FctTextarea,
];
export var fctParamUITypes = [
    'token',
    'address',
    'string',
    'tokenIndex',
    'integer',
    'number',
    'decimals',
    'string[]',
    'integer[]',
    'address[]',
    'anyType',
    'account',
];
